import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faCheck, faGlobe, faPrint, faTimes,
} from '@fortawesome/pro-light-svg-icons'

import { Box, Button, Form } from '@domain-group/suit-theme'

import { ArtworkDownload } from '@domain-group/artwork-builder'

import { confirmAction, confirmDelete } from '@functions/entity'

import type { UseArtworkPayload } from '@hooks/useArtwork'
import type { UseOrderItemPayload } from '@hooks/useOrderItem'

import EnabledPermission from '@components/EnabledPermission'
import { getCampaignType } from '@functions/campaign'

interface ManageArtworkActionsProps {
  artworkPayload: UseArtworkPayload,
  orderItemPayload: UseOrderItemPayload,
}

const ManageArtworkActions = (props: ManageArtworkActionsProps) => {
  const { artworkPayload, orderItemPayload } = props
  const {
    campaign,
    callbacks: {
      approveArtwork: approveFn,
      unapproveArtwork: unapproveFn,
    },
    isUploadedArtwork,
  } = artworkPayload
  const {
    artwork, artworkApproved, artworkUnapprovable, canChangeArtworkStatus, canDownloadPrintQualityArtwork,
  } = orderItemPayload

  return (
    <Form.Field label="More Options" marginTop="large">
      <Box alignItems="center" flexDirection="column">

        {canDownloadPrintQualityArtwork && (
          <Button
            buttonStyle="secondaryUtility"
            icon={<FontAwesomeIcon icon={faPrint} />}
            size="medium"
            // @ts-expect-error
            width="100%"
          >
            <ArtworkDownload artwork={artwork} key="print">
              <a href={artwork.links?.download_url}>
                Print Quality PDF
              </a>
            </ArtworkDownload>
          </Button>
        )}

        {!isUploadedArtwork && (
          <Button
            buttonStyle="secondaryUtility"
            icon={<FontAwesomeIcon icon={faGlobe} />}
            // @ts-expect-error
            marginTop={canDownloadPrintQualityArtwork ? 'medium' : ''}
            size="medium"
            width="100%"
          >
            <ArtworkDownload artwork={artwork} key="web" queryParams={{ low_res: true }}>
              <a href={`${artwork.links?.download_url}?low_res=true`}>
                Web Quality PDF
              </a>
            </ArtworkDownload>
          </Button>
        )}

        <EnabledPermission
          campaignType={getCampaignType(campaign)}
          permissionKey="campaign.artwork.approve"
        >
          <>
            {canChangeArtworkStatus && !artworkApproved && (
              <Button
                buttonStyle="secondaryUtility"
                icon={<FontAwesomeIcon icon={faCheck} />}
                // @ts-expect-error
                marginTop="medium"
                size="medium"
                width="100%"
                onClick={() => confirmAction({
                  callbacks: {
                    actionFn: approveFn,
                  },
                  strings: {
                    actionString: 'approve',
                    entityName: 'artwork',
                  },
                })}
                tabIndex={0}
              >
                Approve Artwork
              </Button>
            )}

            {artworkUnapprovable && (
              <Button
                buttonStyle="secondaryUtility"
                icon={<FontAwesomeIcon icon={faTimes} />}
                // @ts-expect-error
                marginTop="medium"
                size="medium"
                width="100%"
                onClick={() => confirmDelete({
                  callbacks: {
                    deleteFn: unapproveFn,
                  },
                  strings: {
                    deleteString: 'unapprove',
                    entityName: 'artwork',
                  },
                })}
                tabIndex={0}
              >
                Unapprove Artwork
              </Button>
            )}
          </>
        </EnabledPermission>
      </Box>
    </Form.Field>
  )
}

export default ManageArtworkActions
